// src/utils/imageCompressor.js

export function processRoleIcon(file, targetSize = 128) {
  return new Promise((resolve, reject) => {
    if (!file) {
      return resolve(null);
    }

    // Проверка типа
    if (!file.type.match(/image\/(png|jpeg|jpg|webp)/)) {
      return reject(new Error('Поддерживаются только PNG, JPG и WebP'));
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = targetSize;
        canvas.height = targetSize;
        const ctx = canvas.getContext('2d');

        // Вычисляем центральный квадрат (Center Crop)
        const minSide = Math.min(img.width, img.height);
        const startX = (img.width - minSide) / 2;
        const startY = (img.height - minSide) / 2;

        // Рисуем обрезанное изображение на canvas
        ctx.drawImage(
          img,
          startX, startY, minSide, minSide,
          0, 0, targetSize, targetSize
        );

        // Получаем Base64 Data URI
        const dataUrl = canvas.toDataURL('image/png');
        resolve(dataUrl);
      };
      img.onerror = () => reject(new Error('Ошибка чтения изображения'));
      img.src = e.target.result;
    };
    reader.onerror = () => reject(new Error('Ошибка чтения файла'));
    reader.readAsDataURL(file);
  });
}